module.exports = __webpack_public_path__ + "0d849e335096ab5bde7c5c8f744d793c.png";